import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_HEALTHCARE_PROVIDER } from "../../config/connString";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "utils/decodedUserDetails";
import { parsedClientDetails } from "utils/parsedClientDetails";

// This api call is being used in request page to update physician/healthcare provider

const updateHealthcareProvider = createAsyncThunk(
  "healthcareProviders/update-healthcare-provider",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const { isClientKedoya } = parsedClientDetails();
      const api = useAxios();

      const response = await api.put(URL_HEALTHCARE_PROVIDER + "/" + data.id, {
        id: data.id,
        firstName: data.firstName || null,
        code: isClientKedoya ? data?.code : null,
        licenseNumber: data.licenseNumber || null,
        licenseExpirationDate: data.licenseExpirationDate || null,
        lastName: data.lastName || null,
        title: data.title || null,
        specialty: data.specialty || null,
        phoneNumber: data.phoneNumber || null,
        email: data.email || null,
        clientId: clientId,
        isActive: data?.isActive,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { updateHealthcareProvider };
